export default __webpack_public_path__ + "static/media/service.ac96f2d0.png";